/**
 * Shared read-only Markdown body CSS (DR-2026-181 render-detail).
 *
 * Single source of truth for the layout/typography of a rendered Markdown doc body,
 * consumed by BOTH the KB DocViewer (`.doc-viewer-md`) and the public PolicyView
 * (`.policy-body`) via the shared `.md-body` class. Eliminates the per-surface render
 * drift DR-2026-181 calls out. The full shared <MarkdownDoc> component extraction
 * (lazy-load + component) remains the parked DR-2026-181 Phase 1/2; this lands the
 * body-CSS render-detail early because both surfaces ship it identically.
 *
 * Why this is needed: react-markdown + remark-gfm emit bare semantic <table>/<pre> with
 * NO class, and nothing styled them — so GFM tables fell through to the browser default
 * (no borders, content-driven column widths), which read as "poorly formatted". These
 * rules target the default block-table layout directly. Each surface adds `md-body` to
 * its existing body wrapper class.
 */
export const MARKDOWN_BODY_CSS = `
  .md-body table { border-collapse: collapse; width: 100%; margin: 1rem 0; font-size: 0.95em; line-height: 1.45; }
  .md-body th, .md-body td { border: 1px solid #d4d4d5; padding: 0.5em 0.75em; text-align: left; vertical-align: top; }
  .md-body thead th { background: #f3f4f6; font-weight: 600; }
  .md-body tbody tr:nth-child(even) { background: #fafafa; }
  .md-body table code { background: #f3f4f6; padding: 0.1em 0.3em; border-radius: 3px; }
  .md-body pre { overflow-x: auto; font-size: 0.78em; line-height: 1.35; }
`;
